// @flow

import { default as Template } from './templates/template.html';
import { LoaderViewModel } from './view-model';

// less: modules/rgs-nfd-ui-kit/less/layout/less/loader.less

export const COMPONENTS_LOADER_NAME = 'loader';
export const COMPONENTS_LOADER_ENTITIES = [{
	name: COMPONENTS_LOADER_NAME,
	entity: LoaderViewModel,
	template: Template,
}];
